/* Set Shipping Days */
orderArrivesString = '';
const deliveryDays = {
  'USD': {
      1: [{
          "dispatched": 1,
          "arrival": 2
      }],
      2: [{
          "dispatched": 2,
          "arrival": 3
      }],
      3: [{
          "dispatched": 3,
          "arrival": 4
      }],
      4: [{
          "dispatched": 4,
          "arrival": 5
      }],
      5: [{
          "dispatched": 5,
          "arrival": 1
      }],
      6: [{
          "dispatched": 1,
          "arrival": 2
      }],
      7: [{
          "dispatched": 1,
          "arrival": 2
      }]
  }
};


/* Set PT Time */
var PtNow = moment().utc().tz("America/Los_Angeles")

/**
Toll Free Time
**/
var tollFreeOpens = PtNow.clone().set("hour", 6).set("minute", 00).set("second", 00),
  tollFreeCloses = PtNow.clone().set("hour", 17).set("minute", 00).set("second", 00),
  london     = moment().utc().tz("Europe/London").format(),
  startDifference = moment.duration(tollFreeOpens.diff(PtNow)),
  endDifference = moment.duration(tollFreeCloses.diff(PtNow));

if( startDifference._data.seconds < 0 && endDifference._data.seconds > 0 && PtNow.day() !== 6 && PtNow.day() !== 7 ){
  jQuery(function($){
      $('#intl-tell').removeClass('hide');
  });
} else {
  jQuery(function($){
      $('#intl-tell').addClass('hide');
  });
}

/**
Free Shipping Time
**/
var freeShippingcloses = PtNow.clone().set("hour", 10).set("minute", 00).set("second", 00);
var freeShippingTicker = setInterval(function() {

  PtNow = moment().utc().tz("America/Los_Angeles");
  let // Set Monday to a holiday if necessary
      mondayHoliday = false,
      // When we pass a certain threshold show a static date
      showStaticDay = false,
      // Add a week to our calculations
      addWeek = false,
      // Set the ISO
      currentISO = ( document.getElementById("shipping-info") ? document.getElementById("shipping-info").getAttribute('data-ship-iso') : 'USD' ),
      // Add a day to the dates if it is not USA and not UK
      addDay = ( document.getElementById("shipping-info") && ( 'USD' == currentISO ) ? false : true ),
      // Set the difference between now and the end of the shipping threshold
      shippingEndsDifference = moment.duration(freeShippingcloses.diff(PtNow)),
      // Set how many hours are left
      hours = shippingEndsDifference._data.hours,
      // Set the minutes left
      minutes = shippingEndsDifference._data.minutes,
      // Set which day we're shipping on
      shoppingDay = PtNow.isoWeekday();

  /**
  * If it's a Friday or Sunday, and we've run out of time, tell the user that the cut-off for ordering is 5pm EDT to get the date
  */
  if( shippingEndsDifference._data.seconds < 0 && ( shoppingDay == 5 || shoppingDay == 7) ) {
      showStaticDay = true;
  } else if( shoppingDay == 6 ){
      showStaticDay = true;
  }

  /*
  * If the cut off is reached, add a day to dispatch, so that we can recalculate ships and arrival dates
  */
  if( shippingEndsDifference._data.seconds < 0 ) {
    shoppingDay = shoppingDay+1;
    shippingEndsDifference = moment.duration(freeShippingcloses.clone().add(1, 'd').diff(PtNow));
    hours = shippingEndsDifference._data.hours;
    minutes = shippingEndsDifference._data.minutes;
  }

  // Set the hour label
  if( 1 == hours && !isNaN(hours) ){
    hours_text = hours + ' hr ';
  } else if( 0 < hours && !isNaN(hours) ){
    hours_text = hours + ' hrs ';
  } else {
    hours_text = '';
  }

  // Set the minute label
  if( 1 == minutes ){
    mins_text = minutes + ' min';
  } else {
    mins_text = minutes + ' mins';
  }
  
  if( null !== document.getElementById("time-to-ship-footer") ) {
      var ship_label = document.getElementById("time-to-ship-footer").getAttribute('data-ships-label');
        time_to_ship_html =  '<strong>' + ship_label + ' Today!</strong> Order in the next <strong class="time_to_ship">' + hours_text + mins_text + "</strong>";
        document.getElementById("time-to-ship-footer").innerHTML = time_to_ship_html;
  }
  
  // If the count down is enabled, show that instead
  if( null !== document.getElementById("time-to-ship") ) {
        var ship_label = document.getElementById("time-to-ship").getAttribute('data-ships-label');
        time_to_ship_html =  '<strong>' + ship_label + ' Today!</strong> Order in the next <strong class="time_to_ship">' + hours_text + mins_text + "</strong>";
        document.getElementById("time-to-ship").innerHTML = time_to_ship_html;
        if( null !== document.getElementById("time-to-ship-footer") ) {
            document.getElementById("time-to-ship-footer").innerHTML = time_to_ship_html;
        }
  // Otherwise show the get it by text
  } else if( null !== document.getElementById("shipping-info") ) {

    // If we are browsing on a weekend etc, assume the shopping day is Monday and take the calcs from there
    if( shoppingDay > 5 ) {
      addWeek = true;
      shoppingDay = 1;
    }

    // Country specific delivery day
    var isoDeliveryDay = ( 'undefined' !== typeof( deliveryDays[currentISO] ) ? deliveryDays[currentISO] : deliveryDays['USD'] )

    /**
    * Here we set the ship and arrival assuming there is no change
    */
    var ships = isoDeliveryDay[shoppingDay][0]["dispatched"]; // Thursday
    var arrives = isoDeliveryDay[shoppingDay][0]["arrival"]; // Thursday

    /**
    * If Monday is a public holiday add time to the counter
    */
    if( true == mondayHoliday && ( arrives == 2 || arrives == 1 ) ) {
      arrives++;
    }

    /**
    * Here we recalculate the shippin and arrivals according to the current day, ISO, etc.
    */
    orderShips = getNextDate(shoppingDay, ships, addDay, addWeek, currentISO);
    orderArrives = getNextDate(shoppingDay, arrives, addDay, addWeek, currentISO);

    /**
    * Make nice labels
    */
    if( ( ships - arrives ) > 2 || ( ships - arrives ) < 0 ) {
      orderArrivesString = orderArrives.format('dddd, MMMM Do');
    } else  {
      orderArrivesString = orderArrives.calendar({
        sameDay: '[Today]',
        nextDay: '[Tomorrow], MMMM Do',
      });
    }

    /*
    - Get it by Wednesday {time and date} order in the next {hours}
    - Get it by Wednesday when you order by {cutoff time}
    - Ships today when you order by {cutoff time}
    */

    let shipping_info_html = false,
        shipping_info_html_footer = false;

    // If if it's USA and we want to show "Get it by x"
    if( showStaticDay && 'USD' == currentISO ) {
        shipping_info_html = 'Get it by <strong>' + orderArrivesString + '</strong> <a href="#shipping-details">Details</a>'; // <br /><span>if ordered by <strong>Monday 1pm EDT!</strong></span>
        shipping_info_html_footer = 'Get it by <strong>' + orderArrivesString + '</strong>'; //  if ordered by <strong>Monday 1pm EDT!</strong>

    // If it's not USA, and we want to show "Get it by x"
    } else if( showStaticDay ){
        shipping_info_html = 'Get it by <strong>' + orderArrivesString + '</strong> <a href="#shipping-details">Details</a><br />';
        shipping_info_html_footer = 'Get it by <strong>' + orderArrivesString + '</strong>';
    
    // If there's time remaining and there are less than 8hrs left
    } else if( shippingEndsDifference._data.seconds > 0 &&  shippingEndsDifference._data.hours < 8 ){
        shipping_info_html = 'Get it by <strong>' + orderArrivesString + '</strong> <a href="#shipping-details">Details</a>'; // <br /><span>Order in the next <strong class="time_to_ship">' + hours_text + mins_text + "</strong></span>
        shipping_info_html_footer = 'Get it by <strong>' + orderArrivesString + '</strong>'; //  Order in the next <strong class="time_to_ship">' + hours_text + mins_text + "</strong>
    
    // If the timer has passed, show order by 1pm EST/EDT
    } else {
        shipping_info_html = 'Get it by <strong>' + orderArrivesString + '</strong> <a href="#shipping-details">Details</a>'; //<br /><span>if ordered by 1pm EDT!</span>
        shipping_info_html_footer = 'Get it by <strong>' + orderArrivesString + '</strong>'; // if ordered by <strong>1pm EDT!</strong>
    }

    if( shipping_info_html !== false ) {
        document.getElementById("shipping-info").innerHTML = shipping_info_html;
        console.log(document.getElementById("shipping-info-footer"));
        if( null !== document.getElementById("shipping-info-footer") ) {
            document.getElementById("shipping-info-footer").innerHTML = shipping_info_html_footer;
        }
    }

    clearInterval( freeShippingTicker );
  }

  if( shoppingDay !== 6 && shoppingDay !== 7 && null !== document.getElementById("cart-time-to-ship") && shippingEndsDifference._data.seconds > 0 && shippingEndsDifference._data.hours < 10 ) {
    jQuery(function($){
      $( '.cart__ships-today-label' ).removeClass('hide')
      if( hours_text + mins_text !== $( '#cart-time-to-ship' ).text() ) $( '#cart-time-to-ship' ).text( hours_text + '' + mins_text );
    });
  }

}, 1000);

$(document).on('click', 'a[href="#shipping-details"]', function(){
  $(this).hide();
  $('.more-shipping-info').removeClass('hide');
});

$(document).on('click', '.more-shipping-info a.modal-close', function(e){
  e.preventDefault();
  $('a[href="#shipping-details"]').show();
  $('.more-shipping-info').addClass('hide');
});

function getNextDate(currentWeekday, desiredWeekday, addDay, addWeek, currentISO ){

  if( desiredWeekday == 5 && ( document.getElementById("shipping-info") && 'USD' !== currentISO ) ) {
    desiredWeekday = 0;
  }
  
  var missingDays = ((desiredWeekday - currentWeekday) + 7) % 7;
  if( addWeek ){
    var returnDate = PtNow.clone().add(1, 'w').isoWeekday(currentWeekday).add(missingDays, 'd');
  } else {
    var returnDate = PtNow.clone().isoWeekday(currentWeekday).add(missingDays, 'd');
  }

  if( addDay ){
    var returnDate = returnDate.clone().add(1, 'd');
  }

  return returnDate;
}
